import React from 'react';
import { CalendarDaysIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
export function HeroSchedule() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3446">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3447">
        <div className="space-y-6 mb-12" data-id="element-3448">
          {/* Schedule Card */}
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3449">
            <div className="p-6 text-center" style={{
            backgroundColor: '#1e3d2f'
          }} data-id="element-3450">
              <h2 className="text-2xl md:text-3xl font-bold uppercase mb-2" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#c8a84b'
            }} data-id="element-3451">
                Fenton Lakes Sportsman Club
              </h2>
              <p className="text-xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-3452">
                Steel Challenge
              </p>
            </div>
            <div className="p-6" data-id="element-3453">
              <div className="flex flex-col sm:flex-row sm:items-start gap-6 mb-6" data-id="element-3454">
                <div className="flex items-start gap-3 flex-1" data-id="element-3455">
                  <CalendarDaysIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                  color: '#1e3d2f'
                }} data-id="element-3456" />
                  <p className="text-base font-semibold" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-3457">
                    Fourth Saturday of every month running March through
                    November
                  </p>
                </div>
                <div className="flex items-start gap-3 flex-1" data-id="element-3458">
                  <ClockIcon size={20} className="flex-shrink-0 mt-0.5" style={{
                  color: '#1e3d2f'
                }} data-id="element-3459" />
                  <div data-id="element-3460">
                    <p className="text-sm" style={{
                    color: '#2a2a2a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3461">
                      Registration opens at <strong data-id="element-3462">9:00am</strong>
                    </p>
                    <p className="text-sm" style={{
                    color: '#2a2a2a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3463">
                      Mandatory safety briefing begins at{' '}
                      <strong data-id="element-3464">9:45am</strong>
                    </p>
                    <p className="text-sm" style={{
                    color: '#2a2a2a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3465">
                      Shooting begins promptly at <strong data-id="element-3466">10:00am</strong>
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://practiscore.com/clubs/fenton-lakes-sportsmans-club" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full sm:w-auto sm:inline-flex py-3 px-6 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3467">
                <ExternalLinkIcon size={16} data-id="element-3468" />
                Click here to Pre-Register with PractiScore
              </a>
            </div>
          </div>

          {/* YouTube Video - Full Width */}
          <div className="rounded-xl overflow-hidden shadow-sm" data-id="element-3469">
            <div className="relative w-full" style={{
            paddingBottom: '56.25%'
          }} data-id="element-3470">
              <iframe className="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/1RkiQnF7INU" title="What is the FLSC Steel Challenge?" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-3471" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}